export default __webpack_public_path__ + "static/media/gallery - prince vs clean_01.b69fd532.jpg";